import React from "react";

/**
 * Names what the picker is inserting into — feeds the header tag and the
 * confirm button's "Insert N items into {title}" copy. Own module so
 * `SearchItemInputModal.tsx` (the provider) and `SearchProductsAndTemplates.tsx`
 * (a consumer) don't import each other.
 */
export interface SearchItemInputDestination {
  itemId: string;
  title: string;
}

export const SearchItemInputDestinationContext =
  React.createContext<SearchItemInputDestination | null>(null);

export const useSearchItemInputDestination = () =>
  React.useContext(SearchItemInputDestinationContext);
